// trim doesn't work on composition
export function pickUnderlyingVideoElement(
  elementSource: Record<string, any>,
): Record<string, any> | undefined {
  if (elementSource.type === 'composition') {
    const innerEl = elementSource.elements.find(
      (el: any) => el.type === 'video',
    );
    return innerEl;
  } else {
    return elementSource;
  }
}

export function pickUnderlyingVideoElements(
  elementSource: Record<string, any>,
): Record<string, any>[] {
  if (elementSource.type === 'composition') {
    // Return ALL video elements in the composition, not just the first one
    return elementSource.elements.filter((el: any) => el.type === 'video');
  } else if (elementSource.type === 'video') {
    return [elementSource];
  } else {
    return [];
  }
}
